<template>
 <div  class="card card-client shadow">
    <div class="card-body pb-1 pl-1" v-if="dealer && dealer.identifier">
        <div class="selected">
        <div class="row">
            <div class="col">
            <p class="dealer-name">{{dealer.fantasy_name}}</p>
            <p class="dealer-id mb-0">Código: {{dealer.id}}</p>
            </div>
            <div class="col text-right">

                <template v-if="hasLocalData">
                    <div class="alert p-1 mb-2 text-center" :class="status.alert" style="max-width: 150px; margin: 0 auto;">
                        {{status.label}}
                    </div> 
                    <div class="text-center" v-if="control">
                        <p class="m-0 mb-1 small">Actualizado por: <strong>{{control.user}}</strong> </p>
                        <p class="m-0 mb-1 text-muted small">Fecha Inicio: {{control.startDate | formatDateTime}}</p> 
                    </div>
                </template>

                <button v-if="showAddButton && !hasLocalData" :disabled="loadingServices" type="button" class="btn btn-success" @click="addDealer()">Agregar</button>
            </div>
        </div>
        </div>
    </div>
    <div class="card-header">
        <div class="row">
            <div class="col py-2 px-4">Clientes seleccionados</div>
            <div class="col py-2 px-4 text-right" v-if="selectedDealers.length > 0">
                <button class="btn btn-link text-muted btn-sm" type="button" @click="selectedDealers = []"><i class="fas fa-trash text-muted"></i> Limpiar todo</button>
            </div>
            
        </div>
    </div>
    <div class="card-body1">
        <div class="table-responsive">
            <table class="table">
            <thead class="bg-secondary">
                <tr>
                    <th>Código</th>
                    <th>Nombre</th>
                    <th>Status</th>
                    <th class="text-center">Quitar</th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="selectedDealers.length === 0">
                    <td class="text-center py-4 text-muted" colspan="4">Agrega uno o más clientes</td>
                </tr>
                <tr  v-for="(item, index) in selectedDealers" :key="item.identifier">
                    <td >
                        <span class="m-0 text-muted">{{item.id}}</span>
                    </td>
                    <td >
                        <span class="m-0">{{item.fantasy_name}}</span>
                    </td>
                    <td>

                        <span v-if="!item.status" class="text-muted ">Pendiente</span>

                        <div v-if="item.status && item.status != 'done' && !item.error">
                            <span v-if="item.loading" class="fas fa-spinner fa-spin text-info mr-1"></span> 
                            <span class="text-muted">{{ item.status }}</span>
                        </div>
                       
                       <div class="text-danger" v-if="!item.loading && item.error">
                           Ocurrió un error: <br> {{item.status}}
                       </div>

                       <div class="text-success" v-if="!item.loading && item.status && item.status == 'done' && !item.error">
                           Migrado correctamente
                       </div>

                    </td>
                    <td class="text-center">
                        <button type="button" class="btn btn-sm btn-white text-danger" 
                        :disabled="item.loading" @click="removeDealer(index)">
                        <i class="fas fa-minus"></i></button>
                    </td>
                </tr>
            </tbody>
            </table>
        </div>
    </div>
    <div class="card-footer text-right">
        <span class="text-muted small d-block mb-2">Por defecto se agregará adicionalmente el servicio <u>Autos Usados</u></span>
        <button type="button" class="btn btn-primary" @click="handleSetService()" :disabled="!arrayValidForMigration > 0 || processRunning">{{ processRunning ? 'Procesando...' : 'Migrar clientes' }}</button>
    </div>
</div>
</template>
<script>
import utils from "@/helpers/utils";
import Auth from "@/helpers/middleware";
import { Dealer, Control } from "./model";
import sysMsg from '@/helpers/system.message'
import migrationServices from "@/services/migration.services";

export default {
    name: "Multiple",
    props: ['disableUpdate', 'dealer', 'loadingServices', 'hasLocalData', 'status', 'control'],
    data() {
        return {
            selectedDealers: [],
            loading: false,
            user: Auth.getUser(),
        }
    },
     filters: {
        formatDateTime(str) {
        return str ? utils.formatDateTime(str) : 'N/A';
        }
    },
    computed: {
        showAddButton() {
            return this.dealer && this.dealer.identifier && !this.disableUpdate && this.arrayValidForMigration < 11;
        },
        isMigrated() {
            return true;
        },
        processRunning() {
            return this.selectedDealers.filter(item => item.loading).length > 0
        },
        arrayValidForMigration() {
            return this.selectedDealers.filter(item => this.isValidForMigration(item)).length
        }
    },
    methods: {
        addDealer() {
            if(!this.selectedDealers.find(item => item.identifier === this.dealer.identifier)) {
                this.selectedDealers.push(this.dealer);
            }
        },
        removeDealer(index) {
            this.selectedDealers.splice(index, 1);
        },
        handleSetService() {
            sysMsg.getConfirm("Esta acción no se puede revertir", "warning", `¿Migrar ${this.arrayValidForMigration} cliente(s) a Control Panel?`).then(result => {
                if(result.value) {
                    for(var d of this.selectedDealers.filter(item => this.isValidForMigration(item))) {
                        //this.$emit("update:dealer", new Dealer());
                        this.startQeue(d);
                    }
                }
            });
        },
        setLocalDealer(dealer) {
            const { handleDealerStatus } = this;
            handleDealerStatus(dealer, true, 'Procesando migración a CP: 2/2')
            migrationServices.localApi.setDealerService(dealer.identifier, this.user).then(data => {
                handleDealerStatus(dealer, false, 'done');
                this.$parent.getServices(this.dealer.identifier);
                this.$parent.getLocalDealer(this.dealer.identifier);
            }).catch(error => {
                console.log('setLocalDealer', error.message)
                handleDealerStatus(dealer, false, 'No se pudo guardar registro de control', true);
            });
        },
        setDealerService(dealer, serviceIdentifier) {
            this.handleDealerStatus(dealer, true, 'Procesando migración a CP: 1/2');
            return migrationServices.cpApi.setDealerService(dealer.identifier, serviceIdentifier, false);
        },
        startQeue(dealer) {
            const { handleDealerStatus } = this;
            Promise.all([
                //Set CP Service
                this.setDealerService(dealer, "38668026-3425-45ce-9de2-2b3007cd1779"),
                //Set USED CARS Service
                this.setDealerService(dealer, "a3517ac1-5b44-4d5f-ae49-a953ea2f39d2"),
                
            ]).then(res => { 
                    handleDealerStatus(dealer, true, 'Procesando migración a CP: 1/2')
                    //Save in Local Database
                    this.setLocalDealer(dealer)
            }).catch(errors => {
                console.log('errors', errors);
                handleDealerStatus(dealer, false, 'Error al realizar migración a CP.', true);
            });
        },
        handleDealerStatus(dealer, loading, status, error) {
            let dealers = [...this.selectedDealers];
            const index = dealers.findIndex(item => item.identifier === dealer.identifier);

            dealers[index] = {
                ...dealers.find(item => item.identifier === dealer.identifier),
                loading,
                status,
                error
            };
            this.selectedDealers = [...dealers]
        },
        isValidForMigration(item) {
            return !item.status || (item.status && item.status != 'done')
        }
    }
}
</script>